import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  height: '100vh',
});

const LogoText = styled('h1')(({ theme }) => ({
  fontSize: '32px',
  fontWeight: 'bold',
  fontFamily: theme.typography.fontFamily,
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(3),
  padding: theme.spacing(3),
  color: theme.palette.primary.main,
}));

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    const returnTo = sessionStorage.getItem('returnTo');
    if (returnTo) {
      sessionStorage.removeItem('returnTo');
      loginWithRedirect({ appState: { returnTo } });
    } else {
      loginWithRedirect();
    }
  };

  return (
    <PageContainer>
      <LogoText>3D Admin</LogoText>
      <Button onClick={handleLogin} variant="contained" color="primary">Login</Button>
    </PageContainer>
  );
};

export default LoginPage;